import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';

export const mutations = {
    [MUTATIONS.SET_CLIENT](state, { client }) {
        if (!state.clients[client.uuid]) {
            Vue.set(state.clients, client.uuid, client);
        }
        Object.assign(state.clients[client.uuid], client);
    },
};
